module.exports = __webpack_public_path__ + "img/Lego_Adults_cs.5ab39717.png";